import React, { Component } from 'react';
import queryString from 'query-string';

export class SearchResult extends Component {
    displayName = SearchResult.name
    constructor(props) {
        super(props);
        this.state = { //this is a temporary fix for hiding/showing links if not logged in -  condition will be modified 
            searchVal: ''
        }
    }

    componentDidMount() {
        let url = this.props.location.search;
        let params = queryString.parse(url);
        var searchvalue = params.searchText;
        this.setState({ searchVal: searchvalue });
    }

    render() {
        return (
            <div className="col-12" >
                <div className="row">
                    <div className="col-lg-12 colPadding margintop">
                        <p className="PublicationTitle">YOU SEARCHED FOR : {this.state.searchVal}</p>
                        <p>We are sorry, no documents were found to match your criteria.</p>
                    </div>
                </div>
                <div className="row">
                    <div className="White"></div>
                </div>
                <div className="row">
                    <div className="White"></div>
                </div>
                <div className="row">
                    <div className="White"></div>
                </div>
                <div className="row">
                    <div className="White"></div>
                </div>
                <div className="row">
                    <div className="White"></div>
                </div>
                <div className="row">
                    <div className="White"></div>
                </div>
                <div className="row">
                    <div className="White"></div>
                </div>
                <div className="row">
                    <div className="White"></div>
                </div>
            </div>
        );
    }
}
export default SearchResult;


// WEBPACK FOOTER //
// ./src/components/Maintenance/SearchResult.jsx